import { promptDescriptionLabels } from "@revbox/localization";

export const PromptDescription = ({language}) => {
    return (
        <small>
            {promptDescriptionLabels[language].specific_inventory_tagline_prompt}
        </small>
    )
}